<template>
  <div id="GameDetail">
    <!-- <a-carousel ref="endProsition" :autoplay="autoplay" :dots="false" :afterChange="loopChange">
      <div v-for="(item,index) in current.bannerImg" :key="index">
        <img class="bannerImg" :src="item.url" v-if="item.type==='img'">
        <video
          :index="index"
          v-else
          ref="videos"
          :poster="item.videourl"
          class="bannerImg"
          :src="item.url"
          controls
        ></video>
      </div>
    </a-carousel> -->
    <!-- 轮播图下标  -->
    <!-- <div class="loopIndex" ref="loopItem">
      <div
        class="loopItem"
        v-for="(item,index) in current.bannerImg"
        :key="index"
        @click="loopClick(item,index)"
      >
        <img
          v-if="item.type=='img'"
          :src="item.url"
          alt="index"
          :class="{'loopActive':loopIndex==index}"
        > 
        <img
          v-else
          :src="item.videourl"
          alt="index"
          :class="{'loopActive':loopIndex==index}"
        >  
      </div>
    </div> -->
    <!-- 游戏详情 -->
    <!-- <div class="detailInfo" :class="{'detailInfoLr':noRole}">
      <img class="jqRoleR" v-if="current.gameRoleR" :src="current.gameRoleR" alt>
      <div class="jq-logo" v-if="current.gameLogo">
        <img :src="current.gameLogo" alt="街球logo">
      </div>
      <div class="introduce">
        <div class="introduceTitle">
          <img :src="gameTitle" alt="标题1">
        </div>
        <div class="introduceText">{{current.gameInfoText}}</div>
      </div>
    </div> -->

    <div class="detail_block">
      <p class="title">{{ detail_info.title }}</p>
      <p class="other">{{ detail_info.other }}</p>
      <div class="desc" v-html="detail_info.content"></div>
    </div>
    


  </div>
</template>
<script>
import { Carousel } from "ant-design-vue";
let that = null;
export default {
  name: "Banner",
  data() {
    return {
      // 街球
      jqInfo: {
        bannerImg: [
          { type: "video", url: require("@/assets/jq/jq-video.mp4"),videourl:require("@/assets/jq/jq_video_img.png") },
          { type: "img", url: require("@/assets/jq/jq_loop_02.png") },
          { type: "img", url: require("@/assets/jq/jq_loop_03.png") },
          { type: "img", url: require("@/assets/jq/jq_loop_04.png") },
          { type: "img", url: require("@/assets/jq/jq_loop_05.png") },
          { type: "img", url: require("@/assets/jq/jq_loop_06.png") },
          { type: "img", url: require("@/assets/jq/jq_loop_07.png") }
        ],
        gameLogo: require("@/assets/jq/jq-logo.png"),
        gameRoleR: require("@/assets/jq/jq-role-r.png"),
        gameInfoText:
          "《街球艺术》是一款 3对3 真人竞技街球手游。游戏以“为竞技体验而生”为制作宗旨，采用美式街头风格，您将能在游戏里面跟着HIP-HOP音乐的节奏，用指尖去体验即时 3对3 篮球竞技的乐趣。"
      },
      // 腹黑
      // fhInfo: {
      //   bannerImg: [
      //     { type: "img", url: require("@/assets/fh/fh_loop_01.jpg") },
      //     { type: "img", url: require("@/assets/fh/fh_loop_02.jpg") },
      //     { type: "img", url: require("@/assets/fh/fh_loop_03.jpg") },
      //     { type: "img", url: require("@/assets/fh/fh_loop_04.jpg") },
      //     { type: "img", url: require("@/assets/fh/fh_loop_05.jpg") },
      //     { type: "img", url: require("@/assets/fh/fh_loop_06.jpg") },
      //     { type: "img", url: require("@/assets/fh/fh_loop_07.jpg") }
      //   ],
      //   gameLogo: require("@/assets/fh/fh_logo.png"),
      //   gameInfoText:
      //     "《腹黑Q神传》是一款Q萌卡通风格的MMORPG手游。在游戏中，有着200多种不同的卡通队友等待你去收集和展示；还有各种发色、帽子、翅膀、坐骑、套装道具，打造个性化的你；横行，竖列，单体，群体，上百种技能绚丽展现；通过巧妙的排兵布阵，就能起到以少胜多，以弱胜强的效果；简单的操作，动动手指就能享受游戏的乐趣！"
      // },
      // 欢乐宠物店
      // hlInfo: {
      //   bannerImg: [
      //     { type: "img", url: require("@/assets/hl/hl_loop_01.png") },
      //     { type: "img", url: require("@/assets/hl/hl_loop_02.png") },
      //     { type: "img", url: require("@/assets/hl/hl_loop_03.png") },
      //     { type: "img", url: require("@/assets/hl/hl_loop_04.png") },
      //     { type: "img", url: require("@/assets/hl/hl_loop_05.png") },
      //     { type: "img", url: require("@/assets/hl/hl_loop_06.png") }
      //   ],
      //   gameLogo: require("@/assets/hl/hl_logo.png"),
      //   gameInfoText:
      //     "《欢乐宠物店》里有可爱的猫咪、热情的狗狗、优雅的金鱼,还有漂亮的鸟儿等等等等,应有尽有。而且 作为店主,您可以打造自己的独一无二的宠物商店,不管是地板、地毯、墙纸还是植物摆放、颜色搭配,全都由你做主。您还能和自己的朋友们一起游戏,当然您还 可以去陌生人的商店里面拜访哦。"
      // },
      // 大家来找碴
      // djInfo: {
      //   bannerImg: [
      //     { type: "img", url: require("@/assets/dj/dj_loop_01.png") },
      //     { type: "img", url: require("@/assets/dj/dj_loop_02.png") },
      //     { type: "img", url: require("@/assets/dj/dj_loop_03.png") },
      //     { type: "img", url: require("@/assets/dj/dj_loop_04.png") },
      //     { type: "img", url: require("@/assets/dj/dj_loop_05.png") },
      //     { type: "img", url: require("@/assets/dj/dj_loop_06.png") }
      //   ],
      //   gameLogo: require("@/assets/dj/dj_logo.png"),
      //   gameInfoText:
      //     "《大家来找碴》是为你和你都朋友家人准备的精美游戏,游戏玩法经典、简单但是充满乐趣! 精美的真正高清画面设计,大量有趣的精致关卡, 有挑战性的游戏模式, 所有这一切都是为你准备的!游戏规则轻松有趣, 尤其适合你和你的家人、朋友一起玩, 分享乐趣!"
      // },

      gameTitle: require("@/assets/title.png"),
      autoplay: false,
      first: [],
      last: [],
      invert: [],
      current: {},
      that: this,
      loopIndex: 0,
      noRole: false,
      detail_info: {
        title: "[S32赛季]更新内容策划答疑",
        other: "2025-12-02",
        content: "<p class=\"ql-align-center\"><img src=\"http://jqys-files.oss-cn-shanghai.aliyuncs.com/campaigns/website/article/1764926165225_S32%E7%AD%96%E5%88%92%E7%AD%94%E7%96%91-900X383.jpg\"></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">欢迎各位33er来到本期“</span><strong style=\"color: rgb(0, 102, 204);\">赛季答疑解惑</strong><span style=\"color: rgb(0, 0, 0);\">”！在本次更新中，我们收到许多关于球员技能调整与新角色的细节提问。为了让大家更清晰地理解机制，以下整理了几类高频问题并邀请了</span><strong style=\"color: rgb(0, 0, 0);\">策划</strong><span style=\"color: rgb(0, 0, 0);\">进行详细解答，包括灵巧盖帽、漂移投篮、新球员玲奈与切尔西的技能说明。快来看看吧！</span></p><p><br></p><p><strong style=\"color: rgb(230, 0, 0);\">Q1：本次对尼古拉和露西的“灵巧盖帽”技能优化，是否调整了露西的盖帽距离？​</strong></p><p><span style=\"color: rgb(0, 0, 0);\">A1：本次更新并未调整露西的盖帽距离，仅优化了“灵巧盖帽”的效果机制——现在该技能在对扣篮进行盖帽时也能生效触发，让防守方在应对扣篮进攻时有更多策略选择。</span></p><p><br></p><p><strong style=\"color: rgb(230, 0, 0);\">Q2：关于“漂移投篮”的调整，是针对玛丽一人还是全体球员？​</strong></p><p><span style=\"color: rgb(0, 0, 0);\">A2：本次更新中，“漂移投篮”的改动仅适用于玛丽，旨在优化她的投篮手感与实战表现，其他球员的漂移投篮机制保持不变。</span></p><p><br></p><p><strong style=\"color: rgb(230, 0, 0);\">Q3：新球员玲奈（PG）的应援属性具体是什么？​</strong></p><p><span style=\"color: rgb(0, 0, 0);\">A3：玲奈的应援属性为：速度评级S+、传球评级S、断球评级A+。这将使她成为兼具突破组织与防守压迫性的灵动型控卫。</span></p><p><br></p><p><strong style=\"color: rgb(230, 0, 0);\">Q4：玲奈的“极限加速”技能如何操作？怎样才算成功触发？​</strong></p><p><span style=\"color: rgb(0, 0, 0);\">A4：当玲奈的能量条充满时，在不按方向键的情况下，点击辅助技能键即可进入“极限”状态。触发成功后，在该状态下持球移动也会获得显著速度增益，突破威胁大幅提升。</span></p><p><br></p><p><strong style=\"color: rgb(230, 0, 0);\">Q5：玲奈的“冲刺抢断”在极限状态下成功抢断后，能为她增加多少投篮抗干扰比例？​</strong></p><p><span style=\"color: rgb(0, 0, 0);\">A5：在极限状态下使用“冲刺抢断”并成功完成抢断，玲奈将获得25%的投篮抗干扰加成，持续若干秒，帮助她在反击中更稳定地完成得分。</span></p><p><br></p><p><strong style=\"color: rgb(230, 0, 0);\">Q6：玲奈在极限状态下，自身常驻的投篮抗干扰加成比例是多少？​</strong></p><p><span style=\"color: rgb(0, 0, 0);\">A6：玲奈处于极限状态时，自身会获得20%的投篮抗干扰加成。</span></p><p><br></p><p><strong style=\"color: rgb(230, 0, 0);\">Q7：切尔西的技能“幸运女神”等级效果是否可以叠加？​</strong></p><p><span style=\"color: rgb(0, 0, 0);\">A7：是的，该技能效果可叠加。当技能达到LV3时，最多可累积7层效果，共计提升7%的投篮命中率与干扰抵抗，帮助切尔西在比赛中越战越勇。</span></p><p><br></p><p><strong style=\"color: rgb(230, 0, 0);\">Q8：切尔西“幸运女神”技能中描述“使得本次命中率按照三分线出手计算”，具体是什么意思？​</strong></p><p><span style=\"color: rgb(0, 0, 0);\">A8：该效果是指，无论切尔西实际出手位置距离篮筐多远，系统在计算该次投篮命中率时，都会以三分线附近的命中率基准为准。这意味着即使她在更远位置出手，也能享受三分线区域的命中率判定，极大扩展了她的得分范围。</span></p><p><br></p><p><strong style=\"color: rgb(230, 0, 0);\">Q9：玲奈的技能“极限速度”所增加的速度，是否基于她自身速度属性进行比例加成？​</strong></p><p><span style=\"color: rgb(0, 0, 0);\">A9：是的，“极限速度”提供的速度加成会受到玲奈基础速度属性的影响，基础速度越高，该技能带来的加速收益越明显，能充分发挥其S+速度评级的优势。</span></p><p><br></p><p><strong style=\"color: rgb(230, 0, 0);\">Q10：玲奈的“极限加速”技能能量如何充满？​</strong></p><p><span style=\"color: rgb(0, 0, 0);\">A10：玲奈的“极限加速”能量会随着比赛时间自动缓慢恢复。</span></p><p><br></p><p class=\"ql-align-center\"></p>"
      }
    };
  },
  mounted() {
    // 获取first初始位置
    // let first = this.$refs.loopItem.children;
    // const arr = [...first];
    // this.first = arr.map((ele, index) => ({
    //   index,
    //   info: ele.getBoundingClientRect()
    // }));
    that = this; 
    // 获取当前是那个游戏
    this.currentGame();
  },
  watch: {
    "$route.query.gameName": function(newValue, oldValue) {
      document.documentElement.scrollTop = 0;
      that.loopIndex = 0;
      that.$refs.endProsition.goTo(this.loopIndex); 
      that.currentGame();
    }
  },
  methods: {
    // 更改当前的游戏
    currentGame() {
      const gameName = this.$route.query.gameName;
      this.current = {};
      switch (gameName) {
        case "街球艺术 3对3":
          Object.assign(this.current,this.jqInfo); 
          break;
        // case "腹黑Q神传": 
        //   Object.assign(this.current,this.fhInfo); 
        //   break;
        // case "欢乐宠物店":
        //   Object.assign(this.current,this.hlInfo);  
        //   break;
        // case "大家来找碴":
        //   Object.assign(this.current,this.djInfo);  
        //   break;
        default:
          Object.assign(this.current,this.jqInfo);  
          break;
      } 
      if (!Reflect.has(this.current, "gameRoleR")) {
        this.noRole = true;
      }else{
        this.noRole = false;
      }
      setTimeout(() => {
        this.$refs.videos[0].play();
      }, 2000);
    },
    // 轮播图切换
    loopChange(arg) {
      this.loopIndex = arg;
      // 首先暂停所有视频
      if (Reflect.has(this.$refs, "videos")) {
        this.$refs.videos.forEach(ele => {
          ele.pause();
        });
      }
      // 循环判断当前是否Wie视频
      this.current.bannerImg.forEach((ele, index) => {
        if (ele.type === "video" && index === arg) {
          this.$refs.videos[index].play();
          this.$refs.videos[index].addEventListener("ended", () => {
            this.$refs.endProsition.next();
          });
        }
      });
    },
    loopClick(item, indexs) {
      this.$refs.endProsition.goTo(indexs);
      this.loopIndex = indexs;
      // // 设置结束位置last
      // {
      //   let el = this.$refs.loopItem.children;
      //   this.last = [];
      //   const arr = [...el];
      //   const last = this.$refs.endProsition.$el.getBoundingClientRect();
      //   const { top, left, width, height } = last;
      //   // 计算差值invert
      //   this.invert = this.first.map((ele, index) => {
      //     return {
      //       index,
      //       top: ele.info.top - top,
      //       left: ele.info.left - left,
      //       width:width,
      //       height:height
      //     };
      //   });
      // }

      // // 执行动画
      // {
      //   let el = this.$refs.loopItem.children;
      //   const arr = [...el];
      //   // 当前需要放大的元素的差值
      //   const { left , top ,width ,height}  = this.invert.filter((ele,index)=>index===indexs)[0];

      // }
    }
  },
  components: {
    aCarousel: Carousel
  }
};
</script>
<style lang="stylus" scoped>
@import '../Common/common.styl';

#GameDetail { 
  .loop {
    width: 100%;
    boxShadow();
  }
}

.bannerImg {
  width: 100%;
  max-height: 608px;

  img {
    height: 100%;
    width: 100%;
  }
}

.loopIndex {
  width: 100%;
  flex-around();
  cursor: pointer;
  padding-top: 30px;

  .loopItem {
    width: 140px;
    max-height: 78px;

    img, video {
      width: 100%;
      height: 100%;
    }

    .loopActive {
      border: 3px solid #fff;
    }
  }
}

.detailInfo {
  width: 100%;
  text-align: center;
  paddingPage();
  position: relative;

  .jqRoleR {
    position: absolute;
    right: 0;
    bottom: 0px;
    max-width: 35%;
    width: 35%;
  }

  .jq-logo {
    img {
      max-width: 500px;
    }
  }

  // background:url("../../assets/jq-bg.jpg");
  // background-repeat :no-repeat;
  // background-position :center center;
  // background-size 100% 100%
  // video{
  // position absolute
  // left:0;
  // top:0;
  // width:100%;
  // height:100%;
  // }
  // }
  .introduce {
    padding: 50px 0px 50px 0px;

    .introduceTitle {
      width: 54%; 
      img {
        width: 100%;
      }
    }

    .introduceText {
      width: 54%;
      text-align: left;
      text-indent: 34px;
      font-size: 18px;
      padding-top: 40px;
    }
  }
}

@media screen and (min-width: 1100px) {
  .detailInfoLr {
    flex-around();
    padding: 40px 0px !important;

    .introduce {
      .introduceTitle, .introduceText {
        width: 100% !important;
      }

      .introduceText {
        padding-top: 50px !important;
      }
    }
  }
}

@media screen and (max-width: 650px) {
  .introduceTitle {
    width: 100% !important;
  }

  .introduceText {
    width: 100% !important;
  }

  .detailInfo {
    width: 100%;
    padding: 0 !important;
  }

  .jqRoleR {
    display: none;
  }

  .jq-logo {
    width: 100%;
    padding-top: 20px !important;

    img {
      width: 100%;
    }
  }
}

.detail_block {
  width: 100%;
  margin-top: 30px;
  height: auto;
  background-color: #fff;
  padding: 3.203125vw 5.6640625vw;
  box-sizing: border-box;

  .title {
    color: #464646;
    font-family: SourceHanSansCN-Bold;
    font-size: 1.953125vw;
    margin-bottom: .9765625vw;
  }

  .other {
    color: #a9a9a9;
    font-size: .859375vw;
    font-family: SourceHanSansCN-Regular;
    margin-bottom: 2.5390625vw;
  }

  .desc {
    margin: 0 auto;
  }


}

</style> 


// WEBPACK FOOTER //
// src/components/Home/GameDetail.vue